const messages = {
    availPoints: "Available points",
    awaitingPoints: "Pending points",
  board: {
    title: "Dashboard",
    title2: "Performance animation {year}",
    headline1: "Your promotions and points at a glance",
    headline2: "Earn points for your tire purchases.",
    pointsBalanceToDate: "POINTS BALANCE TO DATE",
    availPoints: "Available points",
    awaitingPoints: "Pending points",
    yourRealisation: "YOUR ACHIEVEMENTS",
    yourEngagement: "Your annual commitment: <b>{tyres} tires</b>",
    yourPoints: "YOUR POINTS",
    yourRetailPurchase: "YOUR RETAIL PURCHASES",
    yourRetailPurchaseCCS: "YOUR RETAIL SALES",
    pointsByPurchase: "points generated by your purchases",
    pointsByBoosters: "points generated by boosters",
    pointsByBSPurchase: "Points generated by your Bridgestone purchases",
    pointsByBSPurchaseCCS:
      "Points generated by your Bridgestone tire sales",
    remaining: "Remaining tires",
    yourGoal: "Goal progress",
    unit: "tires",
    buttons: {
      learnMore: "Learn more about your points",
      learnMoreAboutMechanism: "Learn more about the mechanics",
    },
    charts: {
      byBrand: "By brand",
      bySize: "By rim<br/>size",
    },
    exploreResults: "Discover your results",
    tyreLimitInfo:
      "A minimum sell-out volume of 50 Bridgestone and/or Firestone tires is required for each Booster campaign period",
  },
  charts: {
    byBrand: "By brand",
    bySize: "by rim size",
  },

  dashboard: {
    dashboardTitle: "Your benefits",
    dashboardBox: {
      title: "Points balance",
      description: "Your current marketing points total",
      availPoints: "Available points",
      awaitingPoints: "Pending points",
      lastUpdate: "Last update",
      button: "Learn more",
      points: "points",
    },
  },
  soldTyres: "TIRES SOLD",
  receivedPoints: "POINTS EARNED",
  boosterCCS: {
    personalInfo: "Personal information",
    csNumberTitle: "Please specify the participating account number(s)",
    tyresTitle: "Please specify the number of tires sold",
    minTyresInfo:
      "A minimum of {tyres} Bridgestone/Firestone tires is required. Compensation applies only to Bridgestone tires.",
    tyresAmount: "No. of tires",
    filesTitle: "Please upload your proof of sales",
    filesDescription:
      "Please note: only sales specifying tire rim size will be considered.",
    addAnotherFile: "Add another document",
    file: "Upload document",
    formatInfo:
      "Accepted file formats: xlsx, jpeg and pdf. Maximum file size: 8 MB",
    confrimationMessage:
      "<b>Thank you for your participation!</b> <br/>Your request has been received and forwarded to Bridgestone teams for validation.<br/>You will receive an email notification with the results of your Booster CCS participation.<br/>See you soon on Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Share points",
    forShare: "Points you will share",
    title: "Title",
  },
  notFoundFile: "None selected",
  chooseFile: "Choose file",
};
export default {
  messages,
};
